/**
 * stickers — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const stickersPack: ToilePack = {
    slug: 'stickers',
    category: 'stickers',
    name: 'Stickers',
    tagline: tagline('stickers', 'characters', 'finishes'),
    chips: chips('characters', 'finishes'),
    ratio: SQUARE,
    readings: [
        {key: 'frog', label: 'Frog', subject: 'a chubby frog wearing a tiny crown on a lily pad'},
        {key: 'coffee', label: 'Coffee cup', subject: 'a steaming coffee cup with a sleepy face and a scarf'},
        {key: 'cactus', label: 'Cactus', subject: 'a potted cactus with pink flowers and a smile'},
    ],
    styles: [
        {key: 'kawaii', label: 'Kawaii', style: 'cute kawaii, rounded shapes, blush cheeks', palette: 'pastel palette', framing: 'die-cut, white border'},
        {key: 'vintage', label: 'Vintage', style: 'vintage travel-sticker, banner shape', palette: 'muted retro halftone', framing: 'die-cut, white border'},
        {key: 'holo', label: 'Holographic', style: 'holographic foil, chrome highlights', palette: 'iridescent rainbow sheen', framing: 'die-cut, white border'},
    ],
    directions: ['a sleepy fox instead', 'in bold primary colors', 'with a short word'],
}
